import { render, staticRenderFns } from "./PanelCompetitionRegulationForm.vue?vue&type=template&id=0d50818e&scoped=true&"
import script from "./PanelCompetitionRegulationForm.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionRegulationForm.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionRegulationForm.vue?vue&type=style&index=0&id=0d50818e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d50818e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d50818e')) {
      api.createRecord('0d50818e', component.options)
    } else {
      api.reload('0d50818e', component.options)
    }
    module.hot.accept("./PanelCompetitionRegulationForm.vue?vue&type=template&id=0d50818e&scoped=true&", function () {
      api.rerender('0d50818e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelCompetitionRegulationForm.vue"
export default component.exports